export enum Roles {
  ADMIN = 'admin',
  VENDOR = 'vendor',
}
